/* index.tsx generated by @compiled/babel-plugin v0.31.0 */
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ConsentModal = void 0;
require("./index.compiled.css");
var _runtime = require("@compiled/react/runtime");
var _react = _interopRequireDefault(require("react"));
var _modalDialog = _interopRequireDefault(require("@atlaskit/modal-dialog"));
var _new = _interopRequireDefault(require("@atlaskit/button/new"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
// import './ConsentModal.module.css';

/**
 * Component that renders a inline code in topic body
 * @param {ConsentModalProps} ConsentModalProps
 * @returns {React.ReactElement} React.ReactElement
 *
 * @example
 * <ConsentModal onClick={ () => setConsent() } />
 */

var ConsentModal = exports.ConsentModal = function ConsentModal(_ref) {
  var onClick = _ref.onClick;
  return /*#__PURE__*/_react["default"].createElement(_modalDialog["default"], {
    shouldScrollInViewport: true
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _runtime.ax)(["_1e0c1txw _4cvr1h6o _2lx21bp4 _19pk7vkz _ca0q1ylp _u5f31ylp _n3td1ylp _19bv1ylp"])
  }, /*#__PURE__*/_react["default"].createElement("h1", {
    className: (0, _runtime.ax)(["_ect46nat _1wybzwfg _k48pni7l _vwz41ylp _19pkidpf _otyr7vkz _y3gn1h6o"])
  }, "Welcome to Early Access"), /*#__PURE__*/_react["default"].createElement("p", {
    className: (0, _runtime.ax)(["_ect4oyw7 _1wybgktf _k48p1nn1 _vwz41tcg _y3gn1h6o _otyrzwfg"])
  }, "By signing up for the Early Access Program (\u201CEAP\u201D), you acknowledge the", ' ', /*#__PURE__*/_react["default"].createElement("a", {
    href: "http://atlassian.com/legal/privacy-policy",
    className: (0, _runtime.ax)(["_syaz7g9i"])
  }, "Atlassian Privacy Policy"), ' ', "and that use of the EAP products is governed by the", ' ', /*#__PURE__*/_react["default"].createElement("a", {
    href: "https://community.atlassian.com/t5/user/termsofservicepage",
    className: (0, _runtime.ax)(["_syaz7g9i"])
  }, "Online Community Platform Terms of Use"), "."), /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _runtime.ax)(["_ect4zeyy"])
  }, /*#__PURE__*/_react["default"].createElement(_new["default"], {
    appearance: "primary",
    onClick: onClick
  }, "Agree and sign up"))));
};
var contentStyles = null;
var headerStyles = null;
var bodyStyles = null;
var linkStyles = null;
var buttonContainerStyles = null;